/**
 * Community Pulse Widget
 * One-line social proof: how many writers responded to today's prompt.
 */

import React from 'react';
import { Users } from 'lucide-react';

const CommunityPulseWidget = ({ prompt }) => {
  const count = prompt?.responseCount;
  if (count === undefined || count === null) return null;

  return (
    <div className="community-pulse">
      <Users size={16} />
      <span>
        <strong>{count} {count === 1 ? 'writer' : 'writers'}</strong> responded today
      </span>
    </div>
  );
};

export default CommunityPulseWidget;
